'use client';

import { useState, useEffect } from 'react';
import { isMarketOpen } from '@/lib/marketTime';

export function useMarketOpen(): boolean {
  const [open, setOpen] = useState(() => isMarketOpen());

  useEffect(() => {
    const id = setInterval(() => setOpen(isMarketOpen()), 60_000);
    return () => clearInterval(id);
  }, []);

  return open;
}
